export const inUriArray = (arr: Array<string>, uriValue: string) => {
    return arr.some((uri) => uri === uriValue);
};

export const updateUriArray = (arr: string[], uriValue: string): Array<string> => {
    if (!inUriArray(arr, uriValue)) {
        return [...arr, uriValue];
    } else {
        return [...arr].filter((uri) => uri !== uriValue);
    }
};
